import { t } from '../../app/i18n';

// success = Klient schvaleny v APV 
// - warning = System ponuka viac ako 100 EUR
// - danger = V databaze problemovych klientov APV
// - negative = Zaporne amortizovany
// - error = Problemovy
// - big-error = Problemovy (viac)
// - disabled = Zablokovany ucet


export default {
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  negative: 'negative',
  error: 'error',
  'big-error': 'big-error',
  disabled: 'disabled',
};

export const translation = {
  success: t('Klient schválený v APV'),
  warning: t('Systém ponúka viac ako 100 EUR'),
  danger: t('V databáze problémových klientov APV'),
  negative: t('Záporne amortizovaný'),
  error: t('Problémový'),
  'big-error': t('Problémový (viac)'),
  disabled: t('Zablokovaný účet'),
};


// WEBPACK FOOTER //
// ./src/common/enums/miniStatus.js